import React, { Component, PureComponent } from 'react'

export default function FieldGroup(props) {
  let { children, title = false, description = false, submit = false, type = false } = props

  let classes = ['form-group']
  if (submit) classes.push('form-group--submit')

  if (type) classes.push(`form-group--${type}`)

  return (
    <div className={classes.join(' ')}>
      {title ? (
        <div className="form-group-title">
          <div className="form-group-title-text">{title}</div>
          {description ? <div className="form-group-description">{description}</div> : null}
        </div>
      ) : null}
      <div className="form-group-content">{children}</div>
    </div>
  )
}
